import {classNames, React, observer, useCallback, Fragment, Popover2} from '@api'
import {Button, MenuItem, Menu, Popover, MenuDivider} from '@blueprintjs/core'
import {openInNewTab} from '@modules/common'
import {JiraDevMenuItem} from '@modules/dev'
import {useStores} from '@modules/VipLocalStore'
import {deployments, site, ISiteDeployment, DevLoginInfo, dev, nav} from '@stores'
import {ContextMenuItem} from '@modules'
import * as css from './DevDeploymentBrowser.css'
import {Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Chip, Tooltip} from '@material-ui/core'

export const DevDeploymentsMenu = observer<{ className? }>(function DevDeploymentsMenu({className}) {
  const  {selectedDeployment, labelFor} = deployments

  return DEBUG && <div className={classNames(className, css.deploymentMenu)}>
    <Popover2 interactionKind='hover'
             position='bottom-right'
         content={<Menu>
           <DevDeploymentsMenuItems/>
           {/*<MenuDivider />*/}
           {/*<ToggleNestJsServiceMenuItem />*/}
  </Menu>}>
    <Button className={classNames(css.deploymentDropdown)}
            minimal
            rightIcon='caret-down' text={selectedDeployment ? `${labelFor(selectedDeployment)}\n(${selectedDeployment.url})` : `Deployments`} />
  </Popover2>
  </div>
})

export const DevDeploymentsMenuItems = observer(function DevDeploymentsMenuItems() {
  const {deploymentByHeading, navigateToDeployment, selectedDeployment, selectedDeploymentId, idFor, labelFor} = deployments

  return <Fragment>
    {Object.keys(deploymentByHeading)
      .sort()
      .map((customer, i) => (
        <Fragment key={i}>
          <MenuDivider title={customer ?? 'No Customer'} />
          {deploymentByHeading[customer].map((d, j) => {
            const {logins} = d,
              deploymentId = idFor(d),
              isSelected = selectedDeploymentId == deploymentId
            return (
              <MenuItem text={labelFor(d)}
                        title={d.url}
                        key={j}
                        shouldDismissPopover={false}
                        icon={isSelected ? 'tick' : 'blank'}
                        onClick={e => navigateToDeployment(d)}
                        href={nav.urlStringWithQueryParamsOnly({deployment: deploymentId})}
                        children={<MenuItemsForDeployment deployment={d} />}
              />)
          })}
        </Fragment>
      ))}
      <MenuDivider title='Git'/>
    <JiraDevMenuItem/>
    <MenuItem icon='git-branch' text={GIT_BRANCH} target='_blank' href={`https://bitbucket.org/centricsoftware/design-board-ui-2.0/branch/${GIT_BRANCH}`} />
    <MenuItem icon='git-commit' text={`Commit: ${GIT_COMMIT}`} target='_blank' href={`https://bitbucket.org/centricsoftware/design-board-ui-2.0/commits/${GIT_COMMIT}`}/>
    {selectedDeployment && <MenuItem icon='cloud' text={`SSH (Copy to Clipboard)`} onClick={dev.addSshToClipboard}/>}
  </Fragment>
})

export const MenuItemsForDeployment = observer<{deployment: ISiteDeployment}>(function MenuItemsForDeployment({deployment: d}) {
    const {_id, url, logins} = d,
      {deployments: {selectedDeploymentId, navigateToDeployment}} = useStores(),
      isSelected = selectedDeploymentId === _id

    return (<Fragment>
      <MenuItem text='Open Public Site' icon={'share'} onClick={() => openInNewTab(url)}/>
      <MenuDivider/>

      {_.isEmpty(logins) ? <MenuItem text='Load Locally' icon={isSelected ? 'tick' : 'blank'} onClick={e => navigateToDeployment(d)}/>
                         : [d.login && {label: d.login, login: d.login, password: d.password}, ...logins].filter(_.identity).map((l, k) => <DevDeploymentLoginUserMenuItem key={k} loginInfo={l} deployment={d}/>)}
    </Fragment>)
})

const DevDeploymentLoginUserMenuItem = observer<{loginInfo: DevLoginInfo, deployment: ISiteDeployment}>(function DevDeploymentLoginUserMenuItem({loginInfo: {label, login, password}, deployment}) {
  const {deploymentByHeading, navigateToDeployment, selectedDeployment, devLoginInfo} = deployments,
    onLoadDeployment = useCallback(e => navigateToDeployment(deployment, {login, password}), [deployment, login, password])

    return <MenuItem text={label}
                     shouldDismissPopover={false}
                     icon={selectedDeployment == deployment && devLoginInfo?.login == login ? 'tick' : 'blank'}
                     onClick={onLoadDeployment}>
    </MenuItem>
})

export const ToggleNestJsServiceMenuItem = observer(function ToggleNestJsServiceMenuItem() {
    const {ui: {settings: {services}}} = useStores()

    return (
      <ContextMenuItem
        text='Use NestJS Service?'
        active={services.nest}
        onClick={() => services.nest = !services.nest}
    />)
})


// WEBPACK FOOTER //
// ./src/modules/pages/dev/DevDeploymentBrowser.tsx